import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-quote1-icon',
  templateUrl: './text-quote1.component.html'
})
export class TextQuote1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
